import React from "react";

export function Publications() {
  return (
    <div className="fqxi-shortcodes-publications"></div>
  );
}
